import { useState } from "react";
import { Button } from "./Button";

export function CopyUrlButton({
  url,
  size = "sm",
  variant = "secondary",
  label = "Copy URL",
  copiedLabel = "Copied",
  /** Hide the text under the `sm` breakpoint so the button fits a narrow card. */
  compact,
  className = "",
}: {
  url: string;
  size?: "sm" | "md";
  variant?: "primary" | "secondary" | "ghost";
  label?: string;
  copiedLabel?: string;
  compact?: boolean;
  className?: string;
}) {
  const [copied, setCopied] = useState(false);

  const copy = async () => {
    try {
      await navigator.clipboard.writeText(url);
    } catch {
      const ta = document.createElement("textarea");
      ta.value = url;
      ta.setAttribute("readonly", "");
      ta.style.position = "fixed";
      ta.style.opacity = "0";
      document.body.appendChild(ta);
      ta.select();
      document.execCommand("copy");
      ta.remove();
    }
    setCopied(true);
    window.setTimeout(() => setCopied(false), 1600);
  };

  const textClass = compact ? "hidden sm:inline" : "";

  return (
    <Button
      size={size}
      variant={variant}
      onClick={copy}
      title={url}
      aria-label={copied ? copiedLabel : label}
      className={className}
    >
      {copied ? (
        <>
          <svg className="h-4 w-4 flex-shrink-0" viewBox="0 0 20 20" fill="currentColor">
            <path d="M16.7 5.3a1 1 0 0 1 0 1.4l-7.5 7.5a1 1 0 0 1-1.4 0l-3.5-3.5a1 1 0 1 1 1.4-1.4l2.8 2.79 6.8-6.79a1 1 0 0 1 1.4 0Z" />
          </svg>
          <span className={textClass}>{copiedLabel}</span>
        </>
      ) : (
        <>
          <svg className="h-4 w-4 flex-shrink-0" viewBox="0 0 20 20" fill="currentColor">
            <path d="M8 3a2 2 0 0 0-2 2v8a2 2 0 0 0 2 2h6a2 2 0 0 0 2-2V6.4a2 2 0 0 0-.6-1.4l-2.4-2.4A2 2 0 0 0 11.6 2H8Z" />
            <path d="M4 6a2 2 0 0 0-2 2v8a2 2 0 0 0 2 2h6a2 2 0 0 0 2-2H4V6Z" />
          </svg>
          <span className={textClass}>{label}</span>
        </>
      )}
    </Button>
  );
}
